import './styles.scss';
import createElement from '../../utils/createElement';

import Wrap from '../ScreenWrap';
import OpenSeadragon from 'openseadragon';
import zoomImg from '../../../img/japan.dzi';
 import japanImg from '../../../img/japan.jpg';
import loadPhoto from '../../utils/loader';

class Screen4 {
    constructor(loader, updateParams){
        this.html = {};
        this.wrap = null;
        this.isFocused = false;
        this.isEntered = false;
        this.isLoaded = false;
        this.loader = loader;

        this.done = false;
        this.updateParams = updateParams;
        this.img = null;
        this.lastLoadedPercent = 0;

        this.fit = this.fit.bind(this);
        this.zoom = this.zoom.bind(this);
        this.zoomed = 0;
        this.hideTimeout = null;
        this.xhr = null;

        this.finalTitleTimeout = null;
        this.max = false;
        this.zoomPoint = new OpenSeadragon.Point(0.24, 0.31);
        this.baseZoomPoint = new OpenSeadragon.Point(0.24, 0.31);
    }

    paramsUpdated() {
        if (this.isFocused) {
            this.updateParams(this.isFocused, this.isEntered, this.isLoaded);
        }
    }

    setState(state) {
        switch (state) {
            case 'onzoom': {
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.content.classList.remove('invisible');
                this.content1.classList.add('invisible');
                return;
            }

            case '1': {
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.content.classList.remove('invisible');
                this.content1.classList.remove('invisible');
                this.content2.classList.add('invisible');
                return;
            }
            case '2': {
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.content.classList.remove('invisible');
                this.content1.classList.add('invisible');
                this.content2.classList.remove('invisible');
                if (this.isEntered && this.isFocused) {
                    ga('s8.send', 'event', 'Japan', 'final_text');
                }
                return;
            }
            case 'initial': {
                this.html.mainTitle.style.opacity = 1;
                this.html.countryName.style.opacity = 0;
                this.content.classList.add('invisible');
                this.content1.classList.add('invisible');
                this.content2.classList.add('invisible');
                this.done = false;
                return;
            }

            case 'nothing': {
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                this.content.classList.remove('invisible');
                this.content1.classList.add('invisible');
                this.content2.classList.add('invisible');
                return;
            }

            case 'afterall': {
                this.done = true;
                this.content.classList.remove('invisible');
                this.content1.classList.add('invisible');
                this.content2.classList.add('invisible');
                this.html.mainTitle.style.opacity = 0;
                this.html.countryName.style.opacity = 1;
                return;
            }
        }
    }

    render(mountNode){
        this.html.mountNode = mountNode;

        this.html.mainTitle = <h2 class="japan-content__main-title">Япония</h2>;

        this.html.shadowFilter = <div class="japan-content__shadow-filter"/>;

        this.title1 = <div class="japan-content__title-1">
            Все
            <br/>
            детали
        </div>;
        this.text1 = <div class="japan-content__text-1">
            Прокручивай колесо
            <br/>
            мыши, чтобы проникнуть
            <br/>
            внутрь фотографии
        </div>;
        this.deepImage = <div class="japan__img" id="dzi" />;
        this.content2 = <div class="japan_2 invisible">
            { this.title2 = <div class="japan-content__title-2">Камера,<br/>способная на все</div> }
            { this.text2 = <div class="japan-content__text-2">
                Снимает фотографии
                <br/>
                профессионального качества
                <br/>
                и четкие селфи
            </div> }
        </div>;
        this.content1 = <div class="japan_1 invisible">
            { this.title1 }
            { this.text1 }
        </div>;
        this.content = <div class="japan invisible">
            { this.deepImage }
            { this.html.shadowFilter }
            { this.content1}
            { this.content2 }
        </div>;

        this.html.countryName = <h3 class="japan-content__country-name">Япония</h3>;
        this.html.countryName.style.opacity = 0;

        this.container = <div class="japan" id="japan">
            { this.html.mainTitle }
            { this.html.countryName }
            { this.content }
        </div>;
        this.wrap = new Wrap(this.container);
        this.wrap.mountTo(this.html.mountNode);
    }

    size(heigth, width){
        this.wrap.size(heigth, width);
    }

    focus() {
        this.isFocused = true;
        this.paramsUpdated();
        if (this.isLoaded && this.isEntered) {
            this.init();
        }

        if (!this.isEntered){
            this.setState('initial');
        }
    }

    unFocus() {
        this.isFocused = false;
        if (!this.isLoaded) {
            if (this.xhr !== null) {
                this.xhr.abort();
            }
            this.isEntered = false;
            this.loader.loadFinished();
            this.setState('initial');
        }

        this.paramsUpdated();
        this.removeEventListeners();
    }

    preload() {
        loadPhoto(japanImg,
            p => {
                // console.log('japan ', p);
                this.lastLoadedPercent = p;
                if (this.isFocused && this.isEntered) {
                    this.loader.progress(p)
                }
            },
            11812846).then(img => {
            this.img = img;
            if (this.isEntered && this.isFocused) {
                this.loaded();
            }
        });
    }

    loadPhoto() {
        this.loader.loadStarted(this.lastLoadedPercent);
        if (this.img) {
            this.loaded();
        }
         //loadPhoto(japanImg, this.loader.progress, 11812846, xhr => { this.xhr = xhr }).then(img => {
         //    this.img = img;
         //    this.loaded();
         //});
     }

    //_loadPhoto() {
    //    this.loaded();
    //}

    loaded() {
        var self = this;
        if (this.isLoaded){
            return;
        }

        this.viewer = OpenSeadragon({
            id: "dzi",
            //debug: true,
            //prefixUrl: "/img/japan_files",
            //tileSources: zoomImg,
            tileSources: {
                type: 'image',
                url: self.img
            },
            showNavigationControl: false,
            panHorizontal: false,
            panVertical: false,
            gestureSettingsMouse: {
                clickToZoom: false,
                scrollToZoom: false
            },
            homeFillsViewer: true
            //wrapHorizontal: true,
            //wrapVertical: true
            //visibilityRatio: 1
        });

        this.viewer.addHandler('open', function() {
            self.isLoaded = true;
            self.loader.loadFinished();
            self.paramsUpdated();
            self.init();
        });
    }

    init() {
        this.done = false;
        this.viewer.viewport.zoomTo(1, this.zoomPoint);
        this.fit();
        this.setState('1');
        this.addEventListeners();
    }

    addEventListeners() {
        window.addEventListener('resize', this.fit);
        if ('onwheel' in window) {
            // IE9+, FF17+, Ch31+
            window.addEventListener("wheel", this.zoom);
        } else if ('onmousewheel' in window) {
            // устаревший вариант события
            window.addEventListener("mousewheel", this.zoom);
        } else {
            // Firefox < 17
            window.addEventListener("MozMousePixelScroll", this.zoom);
        }
    }

    removeEventListeners() {
        window.removeEventListener('resize', this.fit);
        window.removeEventListener('wheel', this.zoom);
        window.removeEventListener('mousewheel', this.zoom);
        window.removeEventListener('MozMousePixelScroll', this.zoom);
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }
    }

    zoom(e) {
        this.setState('onzoom');
        const z = this.viewer.viewport.getZoom();
        const speed = 600 / z; //z > 5 ? 300 : 600;//100 : 150;

        let delta = e.deltaY || e.wheelDelta;

        if (delta > 10) {
            delta = 10;
        }
        if (delta < -10) {
            delta = -10;
        }
        let newZ = z + delta / speed;
        // if (newZ > 9 && !this.done) {
        //     this.setState('2');
        //     this.hideTimeout = setTimeout(() => {
        //         this.setState('afterall');
        //     }, 5000);
        //     this.done = true;
        // }

        if (newZ > 4.8 * this.viewer.viewport.getHomeZoom()) {
            return false;
        }

        if (newZ < this.viewer.viewport.getHomeZoom()) {
            newZ = this.viewer.viewport.getHomeZoom();
        }

        if (newZ > 4.3){
            if (!this.max) {
                this.setState('2');
                if (this.finalTitleTimeout){
                    clearTimeout(this.finalTitleTimeout);
                }
                this.finalTitleTimeout = setTimeout(() => {
                    this.setState('nothing');
                }, 3000);
                this.max = true;
            }
        }else{
            this.max = false;
            if (this.finalTitleTimeout){
                clearTimeout(this.finalTitleTimeout);
            }
            this.setState('nothing');
        }

        this.viewer.viewport.zoomTo(newZ, this.zoomPoint);
    }

    fit() {
        window.viewport = this.viewer.viewport;
        const baseAspect = 1.5;
        let oldBounds = this.viewer.viewport.getBounds();
        const aspectH = oldBounds.height / oldBounds.width;
        //let newBounds = new OpenSeadragon.Rect(0, 0, 1, aspectH);
        const canvasAspect = 1 / aspectH;
        //if (canvasAspect < baseAspect) {
            //const trim = (baseAspect - canvasAspect) / 2;
            //const width = 1 - trim * 2;
            //const height = width * baseAspect;

            //const aspectW = oldBounds.width / oldBounds.height;
            //newBounds = new OpenSeadragon.Rect(0, 0, aspectW, 1);

            //console.log('zoom ', this.viewer.viewport.getZoom(), this.viewer.viewport.getZoom() + canvasAspect);
            //this.viewer.viewport.zoomTo(
            //    this.viewer.viewport.getZoom() + canvasAspect - this.zoomed,
            //    new OpenSeadragon.Point(0.27, 0.31)
            //);
            //return;
        //}
        //console.log(canvasAspect);
        //console.log(newBounds);
        //let newBounds = new OpenSeadragon.Rect(0, 0, 1, aspectH);

        const homeBounds = this.viewer.viewport.getHomeBounds();
        //if (canvasAspect < baseAspect) {
        //    homeBounds.x /= this.viewer.viewport.getHomeZoom();
        //}
        this.viewer.viewport.fitBounds(homeBounds, true);
        const newBounds = this.viewer.viewport.getBounds();
        this.zoomPoint.y = this.baseZoomPoint.y - (this.viewer.viewport.getHomeZoom() - 1) * 0.025;
        setTimeout(() => {
            this.viewer.viewport.zoomTo(this.viewer.viewport.getHomeZoom(), this.zoomPoint, true);
        }, 30);
    }

    clickEnter() {
        this.isEntered = true;
        this.setState('nothing');
        if (this.isFocused) {
            if(this.isLoaded){
                this.init();
            }else{
                this.loadPhoto();
            }
        }
        this.paramsUpdated();
    }

    clickExit() {
        this.isEntered = false;
        this.setState('initial');
        this.paramsUpdated();
        this.removeEventListeners();
    }
}

export default Screen4;


// WEBPACK FOOTER //
// ./src/js/screens/Screen4/index.js